<template>
  <div>
    <div
      v-for="item in items"
      :key="item.CODE"
      class="border border-dark rounded mb-2">
      <div class="border-bottom p-2 bg-dark d-flex justify-content-between">
        <span>{{ item.LOG_DATE }}</span>
        <span
          :class="{'badge-success': item.STATUS > 0, 'badge-danger': item.STATUS < 1}"
          class="badge"
          style="line-height: inherit">
          {{ item.STATUS > 0 ? 'Reviewed' : 'Unreviewed' }}
        </span>
        <!-- <span
          class="font-weight-bold"
          :class="{'text-success': item.STATUS > 0, 'text-danger': item.STATUS < 1}">
          {{item.STATUS > 0 ? 'Reviewed' : 'Unreviewed'}}
        </span> -->
      </div>
      <b-row class="p-2">
        <b-col md="10">
          <i class="fa fa-map-marker text-danger"/>&nbsp;<small>{{ item.CIST.STATION.NAME || 'N/A' }}</small><br >
          <i class="fa fa-car text-success"/>&nbsp;<small>{{ item.CIST.CAR.NAME || 'N/A' }}</small><br >
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HistoryItem',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>
